import * as React from 'react'
import type { PasswordStrength } from 'types/business'
import { getPasswordStrengthMinimumCharsInWords } from '@disco/utils/password'
import PasswordRequirementsList from 'components/password/password-requirements-list'
import { useTranslation } from '@disco/i18n/use-translation'

const WeakPasswordError = ({
  passwordStrength,
}: {
  passwordStrength: PasswordStrength
}): React.ReactElement<'div'> => {
  const { t } = useTranslation('accounts')
  if (passwordStrength === 'standard') {
    return (
      <div>
        {t(
          'accounts:weakPasswordStandard',
          'Sorry! The password you entered doesn’t meet our minimum security requirements. Please ensure it’s at least {{chars}} characters, and contains at least one number. We recommend including both uppercase and lowercase characters, special characters and numbers.',
          { chars: getPasswordStrengthMinimumCharsInWords(passwordStrength) },
        )}
      </div>
    )
  }

  return (
    <div>
      <p>
        {t(
          'accounts:weakPasswordStrict',
          'Sorry! The password you entered doesn’t meet our minimum security requirements. Please ensure it’s at least {{chars}} characters, and contains at least one of each of the following:',
          { chars: getPasswordStrengthMinimumCharsInWords(passwordStrength) },
        )}
      </p>
      <PasswordRequirementsList
        omitMinimumChars
        passwordStrength={passwordStrength}
      />
    </div>
  )
}

export default WeakPasswordError
